import { render, staticRenderFns } from "./allocationStaging.vue?vue&type=template&id=82a96a1e&"
import script from "./allocationStaging.vue?vue&type=script&lang=js&"
export * from "./allocationStaging.vue?vue&type=script&lang=js&"
import style0 from "./allocationStaging.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "allocationStaging.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
